<script setup lang="ts">
const { linkToReclameAqui } = useLinks();
const { customSealsOnBottomSeals } = useLicenses();

const hasCustomSeals = computed(() => {
  return (
    customSealsOnBottomSeals.value && customSealsOnBottomSeals.value?.length
  );
});

const ebacBrasilLink = computed<string>(() => {
  return '';
});
</script>

<template>
  <div :class="$style.footeSeals">
    <FooterItemsSeal
      href="https://play.google.com/store/apps/details?id=br.bet.apostatudo.twa"
      :image="
        getAssetsUrlForCDN('/assets/seals/disponivel-google-play-badge.webp')
      "
      title="Google Play"
    />

    <FooterItemsSeal
      class="be-glamble-aware"
      href="https://www.begambleaware.org/"
      :image="getAssetsUrlForCDN('/assets/seals/BeGambleAware.webp')"
      title="BeGambleAware"
    />

    <FooterItemsSeal
      class="gt-logo"
      href="https://www.gamblingtherapy.org/pt-br/"
      :image="getAssetsUrlForCDN('/assets/seals/gt_logo.webp')"
      :title="$t('footer.game_therapy')"
    />

    <FooterItemsSeal
      v-if="linkToReclameAqui"
      class="reclame-aqui"
      :href="linkToReclameAqui"
      :image="getAssetsUrlForCDN('/assets/seals/reclameaqui.webp')"
      title="Reclame Aqui"
    />

    <NuxtLink
      :class="$style.responsibleGaming"
      no-prefetch
      to="/page/responsible-gaming"
    >
      <BaseIconsParentAdvisor
        :class="$style.parentAdvisor"
        :title="$t('footer.over_18')"
      />
      <span>
        {{ $t('footer.play_responsibly') }}
      </span>
    </NuxtLink>

    <template v-if="hasCustomSeals">
      <FooterItemsSeals
        v-for="(custom, i) in customSealsOnBottomSeals"
        :id="custom?.id || i"
        :key="i"
        :href="custom?.href"
        :size="custom?.size"
        :src="custom?.src"
        :type="custom?.type"
      />
    </template>

    <FooterItemsSeal
      v-if="!!ebacBrasilLink"
      :class="$style.ebacLogo"
      :href="ebacBrasilLink"
      :image="getAssetsUrlForCDN('/assets/seals/ebac.webp')"
      title="Ebac Brasil"
    />

    <FooterItemsSeal
      v-if="!!ebacBrasilLink"
      :class="$style.compulsafe"
      :href="ebacBrasilLink"
      :image="getAssetsUrlForCDN('/assets/seals/compulsafe.webp')"
      title="Compulsafe"
    />
  </div>
</template>

<style module lang="postcss">
.footeSeals {
  @apply flex items-center justify-center flex-wrap gap-y-2 md:gap-y-4 gap-x-4 md:gap-x-5 w-full p-4 md:p-6 select-none;

  .responsibleGaming {
    @apply flex items-center gap-2 text-texts text-xs -mr-1;

    span {
      @apply max-w-[140px] font-bold uppercase;
    }
  }

  .appDownloadSeal {
    @apply h-12 w-auto max-w-[12rem] text-primary;
  }

  .parentAdvisor {
    @apply h-12 w-auto max-w-[12rem] text-primary;
  }

  .ebacLogo {
    @apply h-7 md:h-8 w-auto max-w-40 -mb-1 mt-1 md:mt-0;

    img {
      @apply h-full w-full object-contain;
    }
  }

  .compulsafe {
    @apply h-8 md:h-12 w-auto max-w-52 -mb-1 mt-1 md:mt-0;

    img {
      @apply h-full w-full object-contain;
    }
  }
}
</style>
